<template>
  <font-awesome-icon
    v-if="crm === 'Salesforce'"
    :icon="faSalesforce"
    :class="[$style.container, $style.salesforce]" />
  <font-awesome-icon
    v-else-if="crm === 'HubSpot'"
    :icon="faHubspot"
    :class="[$style.container, $style.hubspot]" />
  <img
    v-else-if="crm === 'Pipedrive'"
    :src="pipedriveIcon" alt=""
    :class="$style.container" />
  <img
    v-else-if="crm === 'Copper'"
    :src="copperIcon" alt=""
    :class="$style.container" />
  <img
    v-else-if="crm === 'Close'"
    :src="closeIcon" alt=""
    :class="$style.container" />
  <img
    v-else-if="crm === 'Bullhorn'"
    :src="bullhornIcon" alt=""
    :class="$style.container" />  
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faSalesforce } from '@fortawesome/free-brands-svg-icons/faSalesforce'
import { faHubspot } from '@fortawesome/free-brands-svg-icons/faHubspot'

export default {
  components: {
    FontAwesomeIcon
  },
  data () {
    return {
      crm: this.$_hostApp_config.getTeam().crm.name,
      faSalesforce,
      faHubspot,
      pipedriveIcon: this.$_hostApp_config.pipedriveLogoUrl,
      copperIcon: this.$_hostApp_config.copperLogoUrl,
      closeIcon: this.$_hostApp_config.closeLogoUrl,
      bullhornIcon: this.$_hostApp_config.bullhornLogoUrl
    }
  }
}
</script>

<style module lang="less" src="./crm-logo.less"></style>



// WEBPACK FOOTER //
// crm-logo.vue?73ae1942